import type { ReactNode } from 'react'
import { EYEBROW_STYLE, SHADOW_SOFT } from './format'

interface SettingsGroupProps {
  label: string
  children: ReactNode
  /** Optional trailing element on the eyebrow row (e.g. a PRO HOST badge). */
  action?: ReactNode
  /** Render children flush without the card chrome (e.g. when grouping form fields). */
  bare?: boolean
}

export function SettingsGroup({ label, children, action, bare }: SettingsGroupProps) {
  return (
    <section style={{ marginBottom: 26 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={EYEBROW_STYLE}>{label}</div>
        {action}
      </div>
      {bare ? (
        children
      ) : (
        <div
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--line-soft)',
            borderRadius: 20,
            boxShadow: SHADOW_SOFT,
            padding: '4px 18px',
          }}
        >
          {children}
        </div>
      )}
    </section>
  )
}
